import { AGGREGATOR_ID } from 'utils/constants/aggregator'

type OrderSourceConfig = {
  label: string
  classes: string
}

export type OrderSourceChipProps = {
  isGrubtechOrder?: boolean
  isPosOrder?: boolean
  aggregatorCode?: string
  aggregatorName?: string
}

export const getOrderSourceConfig = ({
  isGrubtechOrder,
  isPosOrder,
  aggregatorCode,
  aggregatorName,
}: OrderSourceChipProps): OrderSourceConfig => {
  if (isGrubtechOrder) {
    return {
      label: 'Grubtech',
      classes: 'bg-purple-100 text-purple-700 border-purple-200',
    }
  }
  if (isPosOrder) {
    return {
      label: 'Grand POS',
      classes: 'bg-blue-100 text-blue-700 border-blue-200',
    }
  }
  if (aggregatorCode === AGGREGATOR_ID.deliveroo) {
    return {
      label: 'Deliveroo API',
      classes: 'bg-orange-100 text-orange-700 border-orange-200',
    }
  }
  return {
    label: aggregatorName ? `${aggregatorName} API` : 'Aggregator API',
    classes: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  }
}

const OrderSourceChip = (props: OrderSourceChipProps) => {
  const { label, classes } = getOrderSourceConfig(props)

  return (
    <span
      className={`rounded-full border px-2.5 py-0.5 text-sm font-medium ${classes}`}
    >
      {label}
    </span>
  )
}

export default OrderSourceChip
